import React, { useState, useEffect, useRef } from "react";
import "./featuredList.css";
import { getRecommended } from "../api/core";
import { Link } from "react-router-dom";
import LazyImg from "../lazy/lazy";
import Global from "../../global";
const FeaturedList = (props) => {
  const init = { playlist: [] };
  const mounted = useRef(false);
  const [flPlay, SetFLPlay] = useState(init);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  useEffect(() => {
    mounted.current = true;
    const playlistDetail = async (id, limit, mediaid, offset) => {
      /* eslint-disable no-unused-vars */
      const result = await getRecommended(id, limit, mediaid, offset).then(
        (result) => {
          if (mounted.current) {
            SetFLPlay(result.data);
            SetError(false);
          }
        },
        (error) => {
          if (mounted.current) {
            SetError(true);
          }
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const recomFinal = async (id, mediaid, offset) => {
      const res = await playlistDetail(id, 4, mediaid, offset);
      isLoading(false);
    };

    recomFinal(
      Global.RVPL ? Global.RVPL : props.recomm,
      props.videoId,
      props.offset
    );

    return () => {
      mounted.current = false;
    };
  }, [props.recomm, props.videoId, props.offset]);

  if (!error && !loading && flPlay.size !== 0) {
    return (
      <div
        className="featuredList"
        style={{ paddingTop: Global.TYPE === "News" ? "0px" : "" }}
      >
        <div
          id="viewtube_related_videos-2"
          className="widget widget-video widget_viewtube_related_videos"
        >
          <ul className="sidebar-related-video">
            {flPlay.size !== 0
              ? flPlay.playlist.map((item, index) => (
                  <li key={index}>
                    <div className="related-video-thumb">
                      <Link to={"/" + props.app + "/videopage/" + item.mediaid}>
                        <LazyImg
                          src={item.images[3].src}
                          alt="realimg"
                          orient="landscape"
                          className={Global.BORDER ? "" : "no-border"}
                        />{" "}
                      </Link>
                    </div>
                    <div className="related-video-content">
                      <p>
                        <Link
                          to={"/" + props.app + "/videopage/" + item.mediaid}
                        >
                          {item.title}
                        </Link>
                      </p>
                      <div className="d-flex video-meta-bottom">
                        {item.duration} • Just Now{" "}
                      </div>
                    </div>
                  </li>
                ))
              : ""}
          </ul>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default FeaturedList;
